import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center mt-4 md:space-x-4 md:mt-0" }
const _hoisted_2 = { class: "flex w-full space-x-2 md:w-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "currentColor",
    class: "bi bi-arrow-left",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Back to Event")
], -1)
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = { class: "flex flex-wrap items-center justify-between" }
const _hoisted_7 = { class: "flex items-center space-x-2 font-medium" }
const _hoisted_8 = { class: "text-xl capitalize" }
const _hoisted_9 = { class: "text-base text-normal" }
const _hoisted_10 = { class: "pt-0 mt-0 whitespace-normal" }
const _hoisted_11 = {
  key: 0,
  class: "pr-6"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "w-full my-6 space-y-4 md:w-1/2" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "sr-only" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Information")
  ])
], -1)
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/3 font-medium" }, "Booking ID:", -1)
const _hoisted_18 = { class: "w-1/3 text-right" }
const _hoisted_19 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/3 font-medium" }, "Transaction ID:", -1)
const _hoisted_21 = { class: "w-1/3 text-right" }
const _hoisted_22 = { class: "flex justify-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/3 font-medium" }, "Order date:", -1)
const _hoisted_24 = { class: "w-1/3 text-right" }
const _hoisted_25 = { class: "flex justify-between" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/3 font-medium" }, "Affiliate ID:", -1)
const _hoisted_27 = { class: "w-1/3 text-right" }
const _hoisted_28 = { class: "flex justify-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/3 font-medium" }, "Type:", -1)
const _hoisted_30 = { class: "w-1/3 text-right capitalize" }
const _hoisted_31 = { class: "text-sm text-gray-700" }
const _hoisted_32 = { class: "flex justify-between" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/3 font-medium" }, "Has been refunded?", -1)
const _hoisted_34 = { class: "w-1/3 text-right" }
const _hoisted_35 = { class: "py-4 border-t" }
const _hoisted_36 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_37 = { class: "w-full table-auto" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "w-64 px-2 py-2 whitespace-nowrap md:whitespace-normal"
    }, "Organisation Details"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2 sr-only"
    }, "Organisation Details")
  ])
], -1)
const _hoisted_39 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Name", -1)
const _hoisted_41 = { class: "px-2 py-3 capitalize" }
const _hoisted_42 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }, "Program Setting", -1)
const _hoisted_44 = { class: "px-2 pb-3 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Address", -1)
const _hoisted_53 = { class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_54 = {
  key: 0,
  class: "leading-none"
}
const _hoisted_55 = {
  key: 1,
  class: "leading-none"
}
const _hoisted_56 = { class: "leading-none" }
const _hoisted_57 = {
  key: 0,
  class: "border-b border-gray-400 odd:bg-gray-200"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Booked by", -1)
const _hoisted_59 = { class: "px-2 py-3 capitalize" }
const _hoisted_60 = {
  key: 1,
  class: "border-b border-gray-400 odd:bg-gray-200"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Role", -1)
const _hoisted_62 = {
  key: 0,
  class: "px-2 py-3 capitalize"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "w-full table-auto" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "w-64 px-2 py-2 whitespace-nowrap md:whitespace-normal"
    }, "Delegates"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2 sr-only"
    })
  ])
], -1)
const _hoisted_66 = { class: "px-2 py-3 capitalize" }
const _hoisted_67 = { class: "px-2 py-3 capitalize" }
const _hoisted_68 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_69 = {
  key: 0,
  class: "w-full table-auto"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "w-64 px-2 py-2 whitespace-nowrap md:whitespace-normal"
    }, "Billing Details"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2 sr-only"
    })
  ])
], -1)
const _hoisted_71 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Name", -1)
const _hoisted_73 = { class: "px-2 py-3 capitalize" }
const _hoisted_74 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_75 = {
  key: 1,
  class: "capitalize"
}
const _hoisted_76 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Email", -1)
const _hoisted_78 = { class: "px-2 py-3" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Organisation", -1)
const _hoisted_83 = { class: "px-2 py-3 capitalize" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Address", -1)
const _hoisted_88 = {
  key: 0,
  class: "px-2 py-3 capitalize"
}
const _hoisted_89 = { class: "block" }
const _hoisted_90 = { class: "block" }
const _hoisted_91 = { class: "block" }
const _hoisted_92 = {
  key: 1,
  class: "px-2 py-3 capitalize"
}
const _hoisted_93 = {
  key: 0,
  class: "block"
}
const _hoisted_94 = {
  key: 1,
  class: "block"
}
const _hoisted_95 = {
  key: 2,
  class: "block"
}
const _hoisted_96 = {
  key: 3,
  class: "block"
}
const _hoisted_97 = {
  key: 4,
  class: "block"
}
const _hoisted_98 = {
  key: 5,
  class: "block"
}
const _hoisted_99 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }, "How did you hear about us?", -1)
const _hoisted_101 = { class: "px-2 py-3 capitalize" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = {
  key: 1,
  class: "capitalize"
}
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, null, -1)
const _hoisted_105 = {
  key: 1,
  class: "w-full table-auto"
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "w-64 px-2 py-2 whitespace-nowrap md:whitespace-normal"
    }, "Billing Details"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2 sr-only"
    })
  ])
], -1)
const _hoisted_107 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Name", -1)
const _hoisted_109 = { class: "px-2 py-3 capitalize" }
const _hoisted_110 = { class: "capitalize" }
const _hoisted_111 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Email", -1)
const _hoisted_113 = { class: "px-2 py-3" }
const _hoisted_114 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Organisation", -1)
const _hoisted_116 = { class: "px-2 py-3 capitalize" }
const _hoisted_117 = { key: 0 }
const _hoisted_118 = { key: 1 }
const _hoisted_119 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Address", -1)
const _hoisted_121 = {
  key: 0,
  class: "px-2 py-3 capitalize"
}
const _hoisted_122 = { class: "block" }
const _hoisted_123 = { class: "block" }
const _hoisted_124 = { class: "block" }
const _hoisted_125 = {
  key: 1,
  class: "px-2 py-3 capitalize"
}
const _hoisted_126 = { class: "block" }
const _hoisted_127 = { class: "block" }
const _hoisted_128 = { class: "block" }
const _hoisted_129 = {
  key: 3,
  class: "overflow-x-auto"
}
const _hoisted_130 = { class: "w-full table-auto" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "w-64 px-2 py-2"
    }, "Individual Details"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2 sr-only"
    })
  ])
], -1)
const _hoisted_132 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Name", -1)
const _hoisted_134 = { class: "px-2 py-3 capitalize" }
const _hoisted_135 = { class: "capitalize" }
const _hoisted_136 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Role", -1)
const _hoisted_138 = {
  key: 0,
  class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal"
}
const _hoisted_139 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }, "Dietary Requirements", -1)
const _hoisted_141 = { class: "px-2 py-3 capitalize" }
const _hoisted_142 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_143 = { key: 1 }
const _hoisted_144 = { class: "border-b border-gray-400 odd:bg-gray-200" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }, "Accessiblity Requirements", -1)
const _hoisted_146 = { class: "px-2 py-3 capitalize" }
const _hoisted_147 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_148 = { key: 1 }
const _hoisted_149 = {
  key: 4,
  class: "overflow-x-auto"
}
const _hoisted_150 = { class: "w-full table-auto" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "w-64 px-2 py-2"
    }, "Course Details"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2 sr-only"
    })
  ])
], -1)
const _hoisted_152 = { class: "" }
const _hoisted_153 = { class: "border-b border-gray-400" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Course Date", -1)
const _hoisted_155 = { class: "px-2 py-3 capitalize" }
const _hoisted_156 = { class: "bg-gray-200 border-b border-gray-400" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Certified Facilitator complete", -1)
const _hoisted_158 = { class: "px-2 py-3 capitalize" }
const _hoisted_159 = { class: "border-b border-gray-400" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Date completed", -1)
const _hoisted_161 = { class: "px-2 py-3 capitalize" }
const _hoisted_162 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_163 = { class: "px-2 py-3 capitalize" }
const _hoisted_164 = { class: "flex justify-between px-2 py-3 space-x-4 capitalize" }
const _hoisted_165 = { class: "mr-4 font-medium" }
const _hoisted_166 = {
  key: 0,
  class: "whitespace-nowrap md:whitespace-normal"
}
const _hoisted_167 = {
  key: 1,
  class: "whitespace-nowrap md:whitespace-normal"
}
const _hoisted_168 = { key: 0 }
const _hoisted_169 = { key: 0 }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("span", { class: "px-2 text-sm text-white capitalize bg-red-400 rounded-full w-fit" }, "Not Started", -1)
const _hoisted_171 = { key: 1 }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("span", { class: "px-2 text-sm text-black capitalize rounded-full bg-warning w-fit" }, " In Progress ", -1)
const _hoisted_173 = ["href"]
const _hoisted_174 = { class: "border-b border-gray-400 even:bg-gray-200" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Subscription status", -1)
const _hoisted_176 = { class: "px-2 py-3 capitalize" }
const _hoisted_177 = { class: "capitalize" }
const _hoisted_178 = { class: "border-b border-gray-400 even:bg-gray-200" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Subscription renewal", -1)
const _hoisted_180 = { class: "px-2 py-3 capitalize" }
const _hoisted_181 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_182 = { class: "border-b border-gray-400 even:bg-gray-200" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-3 capitalize" }, "Email lists", -1)
const _hoisted_184 = { class: "px-2 py-3 capitalize" }
const _hoisted_185 = { class: "flex items-center space-x-4" }

import { ref } from "vue";
import { useRoute } from "vue-router";

import Button from "@/components/DefaultButton.vue";
import TabGroup from "@/components/TabGroup.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";
import OrderDetailsCard from "@/components/events/OrderDetailsCard.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import { Booking, EmailList, License, User, Transaction } from "@/types";
import { userHasRole } from "@/utils/roles";
import { getPriceSummary } from "@/utils/price";
import { getCertificateUrl, shouldShowCertificateUrl } from "@/utils/certificates";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderPage',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();
const { user } = useUserStore();
const isUpdatingBooking = ref(false);

const booking = ref({} as Booking);
const group = ref(
  {} as {
    booking?: Booking;
    license?: License;
    user: User;
    sub_organisation: string;
    size: number;
    bookings: Booking[];
    groupAdminIsFO: boolean;
    groupAdminIsTO: boolean;
  }
);
const courses = ref([] as Booking[]);

const lists = ref([] as EmailList[]);
const userLists = ref([] as number[]);
const transaction_group = ref([] as Transaction[]);
var subscriptionId = "0";

const tabs = [
  {
    id: "organisation",
    name: "Organisation",
    roles: ["l4a-trainer", "trainer-organisation", "admin"],
  },
  {
    id: "billing",
    name: "Billing",
    roles: ["l4a-trainer", "trainer-organisation", "admin"],
  },
  {
    id: "individual",
    name: "Individual",
    roles: ["l4a-trainer", "trainer-organisation", "admin"],
  },
  {
    id: "course",
    name: "course",
    roles: ["admin"],
  },
];
const selectedTab = ref("organisation");

async function updatePaymentStatus() {
  try {
    const response = (await api.bookings.updateBookingPayment(booking.value.id, { payment_confirmed: booking.value.payment_confirmed })).data.booking;
    booking.value.payment_confirmed = response.payment_confirmed;

    globalStore.toast("SUCCESS", "User's payment status updated");
  } catch (e) {
    console.log(e);
    globalStore.toast("ERROR", "Error updating user's payment status");
  }
}

async function toggleRefunded() {
  try {
    const response = (await api.bookings.updateRefunded(booking.value.id, { refunded: !booking.value.is_refunded })).data;
    booking.value = response.booking;

    if (response.booking.is_refunded === true) {
      globalStore.toast("SUCCESS", "Marked as Refunded");
    }

    if (response.booking.is_refunded === false) {
      globalStore.toast("SUCCESS", "Unmarked as Refunded");
    }
  } catch (e) {
    console.log(e);
    globalStore.toast("ERROR", "Error updating Booking");
  }
}

function getInitiateComplete() {
  const initiate = courses.value.find(course => course.event?.level === "Certified Facilitator");
  return initiate && initiate.completed_at ? new Date(initiate.completed_at).toLocaleDateString() : "Not Started";
}

async function getUserLists() {
  userLists.value = (await api.brevo.getContactInfo(booking.value.user_id)).data.lists;
}

async function updateCompleteStatus() {
  isUpdatingBooking.value = true;
  try {
    const response = await api.bookings.updateBookingAttendance(booking.value.id, { user_attended: booking.value.user_attended });
    booking.value.user_attended = response.data.booking.user_attended;

    globalStore.toast("SUCCESS", "User attendance updated");
  } catch (e) {
    globalStore.toast("ERROR", "Error updating user attendance");
  } finally {
    isUpdatingBooking.value = false;
  }
}

function getRelatedSubscriptionId(transactionGroup: Transaction[]) {
  const subsTransactions = transactionGroup.filter(transaction => transaction.type === "Subscription");

  if (subsTransactions.length === 0) {
    return "0";
  }

  return subsTransactions[0].id;
}

if (!userHasRole(user.roles, ["admin", "courses-admin", "users-admin", "clubs-admin", "trainer-organisation", "l4a-trainer"])) {
  window.location.href = "/error";
}

try {
  const response = ((
  ([__temp,__restore] = _withAsyncContext(() => api.bookings.getBooking(String(route.params.bookingId)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data;
  booking.value = response.booking;

  group.value = response.group || null;

  courses.value = response.courses;
  transaction_group.value = response.transaction_group;
  subscriptionId = getRelatedSubscriptionId(response.transaction_group);

  if (booking.value.payment_method !== "License" && booking.value.transaction) {
    const priceSummary = getPriceSummary(booking.value.transaction);
    booking.value.transaction.price_summary = priceSummary;
  }
} catch (error) {
  window.location.href = "/error";
}

if (booking.value.type === "group" || booking.value.license) {
  tabs.splice(1, 0, {
    id: "group",
    name: "group",
    roles: ["admin"],
  });
}

lists.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.brevo.listEmailLists())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.lists;
;(
  ([__temp,__restore] = _withAsyncContext(() => getUserLists())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(RouterButton, {
          type: "primary",
          to: { name: 'Training_Event', params: { id: _unref(route).params.id } }
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode(TitleHeader, {
        title: `${_ctx.$t('user-order')}`
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, _toDisplayString(booking.value.user.first_name) + " " + _toDisplayString(booking.value.user.last_name), 1),
              _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'users-admin', 'clubs-admin'] }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(" ("),
                    _createVNode(_component_router_link, {
                      class: "text-blue-500",
                      to: { name: 'User_Profile', params: { id: booking.value.user.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("view profile")
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createTextVNode(") ")
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(booking.value.user.email), 1)
          ]),
          (!booking.value.user_attended && !booking.value.user_removed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(RoleGuard, { roles: ['admin'] }, {
                  default: _withCtx(() => [
                    _createVNode(Button, {
                      type: "primary",
                      class: "px-3 py-2 text-sm text-white rounded",
                      loading: isUpdatingBooking.value,
                      onClick: updateCompleteStatus
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Mark as completed ")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }),
                (booking.value.event!.trainer_id === _unref(user).id || booking.value.event!.user_id === _unref(user).id)
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 0,
                      roles: ['l4a-trainer', 'trainer-organisation']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Button, {
                          type: "primary",
                          class: "px-3 py-2 text-sm text-white rounded",
                          loading: isUpdatingBooking.value,
                          onClick: updateCompleteStatus
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Mark as completed ")
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (booking.value.event!.organisation_id === _unref(user).organisation_id && booking.value.event!.trainer_id !== _unref(user).id)
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 1,
                      roles: ['trainer-organisation', 'facilitator-organisation']
                    }, {
                      default: _withCtx(() => [
                        (booking.value.event!.level !== 'Certified Facilitator' && booking.value.user.organisation_id === _unref(user).organisation_id && booking.value.user_id !== _unref(user).id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(Button, {
                                type: "primary",
                                class: "px-3 py-2 text-sm text-white rounded",
                                loading: isUpdatingBooking.value,
                                onClick: updateCompleteStatus
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Mark as completed ")
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("td", _hoisted_18, "#" + _toDisplayString(booking.value.id), 1)
                ]),
                (booking.value.transaction)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("td", _hoisted_21, "#" + _toDisplayString(booking.value.transaction.id), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("td", _hoisted_24, _toDisplayString(new Date(booking.value.created_at).toLocaleDateString()), 1)
                ]),
                _createElementVNode("tr", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, _toDisplayString(booking.value.transaction ? booking.value.transaction.affiliate_id : ""), 1)
                ]),
                _createElementVNode("tr", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("td", _hoisted_30, [
                    _createTextVNode(_toDisplayString(booking.value.type) + " ", 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(booking.value.type === "group" ? `(${group.value.size} places)` : ""), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("td", _hoisted_34, [
                    _createVNode(ToggleCheckbox, {
                      class: "ml-8",
                      value: booking.value.is_refunded,
                      onToggle: toggleRefunded
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'users-admin', 'clubs-admin'] }, {
              default: _withCtx(() => [
                _createVNode(OrderDetailsCard, {
                  booking: booking.value,
                  event: booking.value.event!,
                  group: group.value,
                  transactionGroup: transaction_group.value,
                  subscription: _unref(subscriptionId)
                }, null, 8, ["booking", "event", "group", "transactionGroup", "subscription"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(TabGroup, {
        tabs: tabs,
        selectedTab: selectedTab.value,
        onSelect: _cache[0] || (_cache[0] = (tab) => selectedTab.value = tab),
        "has-role-guard": true
      }, null, 8, ["selectedTab"]),
      (selectedTab.value === 'organisation')
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("table", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("td", _hoisted_41, _toDisplayString(booking.value.organisation.name), 1)
                ]),
                _createElementVNode("tr", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("td", _hoisted_44, [
                    (booking.value.type === 'single' && booking.value.user.programme_setting && booking.value.user.programme_setting.data)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.user.programme_setting.data.filter(i => ['other-1', 'other-2'].includes(i) === false), (setting, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                              class: "leading-none",
                              key: index
                            }, _toDisplayString(setting), 1))
                          }), 128)),
                          (booking.value.user.programme_setting.data.includes('other-1'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(booking.value.user.programme_setting.other.field_1), 1))
                            : _createCommentVNode("", true),
                          (booking.value.user.programme_setting.data.includes('other-2'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(booking.value.user.programme_setting.other.field_2), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (booking.value.type === 'group' && group.value.user.programme_setting && group.value.user.programme_setting.data)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.value.user.programme_setting.data.filter(i => ['other-1', 'other-2'].includes(i) === false), (setting, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                              class: "leading-none",
                              key: index
                            }, _toDisplayString(setting), 1))
                          }), 128)),
                          (group.value.user.programme_setting.data.includes('other-1'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(group.value.user.programme_setting.other.field_1), 1))
                            : _createCommentVNode("", true),
                          (group.value.user.programme_setting.data.includes('other-2'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(group.value.user.programme_setting.other.field_2), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("td", _hoisted_53, [
                    (booking.value.organisation.address_line_one)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(booking.value.organisation.address_line_one) + ", " + _toDisplayString(booking.value.organisation.address_line_two), 1))
                      : _createCommentVNode("", true),
                    (booking.value.organisation.city)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(booking.value.organisation.city) + ", " + _toDisplayString(booking.value.organisation.county), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_56, _toDisplayString(booking.value.organisation.country) + ", " + _toDisplayString(booking.value.organisation.postcode), 1)
                  ])
                ]),
                (booking.value.type === 'group')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("td", _hoisted_59, _toDisplayString(group.value.user.first_name) + " " + _toDisplayString(group.value.user.last_name), 1)
                    ]))
                  : _createCommentVNode("", true),
                (booking.value.type !== 'group')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_60, [
                      _hoisted_61,
                      (booking.value.user.job_role && booking.value.user.job_role.data)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_62, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.user.job_role.data, (role) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "block",
                                key: role
                              }, _toDisplayString(role), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ((selectedTab.value === 'group' && booking.value.type === 'group') || (selectedTab.value === 'group' && booking.value.license))
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createElementVNode("table", _hoisted_64, [
              _hoisted_65,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.value.bookings, (booking) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 odd:bg-gray-200",
                    key: booking.id
                  }, [
                    _createElementVNode("td", _hoisted_66, [
                      _createVNode(_component_RouterLink, {
                        class: "text-blue-500 underline",
                        to: { name: 'User_Profile', params: { id: booking.user.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(booking.user.first_name) + " " + _toDisplayString(booking.user.last_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", _hoisted_67, _toDisplayString(booking.user.email), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'billing')
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            (booking.value.type === 'single')
              ? (_openBlock(), _createElementBlock("table", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("td", _hoisted_73, [
                        (!booking.value.license)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(booking.value.user.first_name) + " " + _toDisplayString(booking.value.user.last_name), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(group.value.license!.user.first_name) + " " + _toDisplayString(group.value.license!.user.last_name), 1))
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("td", _hoisted_78, [
                        (!booking.value.license)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(booking.value.user.email), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(group.value.license!.user.email), 1))
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_81, [
                      _hoisted_82,
                      _createElementVNode("td", _hoisted_83, [
                        (!group.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(booking.value.sub_organisation), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(group.value.sub_organisation), 1))
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_86, [
                      _hoisted_87,
                      (!booking.value.license)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_88, [
                            _createElementVNode("span", _hoisted_89, "123" + _toDisplayString(booking.value.address_line_one) + ", " + _toDisplayString(booking.value.address_line_two), 1),
                            _createElementVNode("span", _hoisted_90, _toDisplayString(booking.value.city) + ", " + _toDisplayString(booking.value.county), 1),
                            _createElementVNode("span", _hoisted_91, _toDisplayString(booking.value.country) + ", " + _toDisplayString(booking.value.postcode), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_92, [
                            (group.value.groupAdminIsFO)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(booking.value.address_line_one) + ", " + _toDisplayString(booking.value.address_line_two), 1))
                              : _createCommentVNode("", true),
                            (!group.value.groupAdminIsFO)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(booking.value.organisation.address_line_one) + ", " + _toDisplayString(booking.value.organisation.address_line_two), 1))
                              : _createCommentVNode("", true),
                            (group.value.groupAdminIsFO)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_95, _toDisplayString(booking.value.city) + ", " + _toDisplayString(booking.value.county), 1))
                              : _createCommentVNode("", true),
                            (!group.value.groupAdminIsFO)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(booking.value.organisation.city) + ", " + _toDisplayString(booking.value.organisation.county), 1))
                              : _createCommentVNode("", true),
                            (group.value.groupAdminIsFO)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(booking.value.country) + ", " + _toDisplayString(booking.value.postcode), 1))
                              : _createCommentVNode("", true),
                            (!group.value.groupAdminIsFO)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(booking.value.organisation.country) + ", " + _toDisplayString(booking.value.organisation.postcode), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("tr", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("td", _hoisted_101, [
                        (booking.value.how_hear_about)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.how_hear_about.data, (item) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "block",
                                  key: item
                                }, _toDisplayString(item), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (booking.value.how_found_out)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(booking.value.how_found_out), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_104
                    ])
                  ])
                ]))
              : (booking.value.type === 'group')
                ? (_openBlock(), _createElementBlock("table", _hoisted_105, [
                    _hoisted_106,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_107, [
                        _hoisted_108,
                        _createElementVNode("td", _hoisted_109, [
                          _createElementVNode("span", _hoisted_110, _toDisplayString(group.value.user.first_name) + " " + _toDisplayString(group.value.user.last_name), 1)
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_111, [
                        _hoisted_112,
                        _createElementVNode("td", _hoisted_113, [
                          _createElementVNode("span", null, _toDisplayString(group.value.user.email), 1)
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_114, [
                        _hoisted_115,
                        _createElementVNode("td", _hoisted_116, [
                          (!group.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(booking.value.sub_organisation), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(group.value.sub_organisation), 1))
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_119, [
                        _hoisted_120,
                        (!booking.value.license)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_121, [
                              _createElementVNode("span", _hoisted_122, _toDisplayString(booking.value.address_line_one) + ", " + _toDisplayString(booking.value.address_line_two), 1),
                              _createElementVNode("span", _hoisted_123, _toDisplayString(booking.value.city) + ", " + _toDisplayString(booking.value.county), 1),
                              _createElementVNode("span", _hoisted_124, _toDisplayString(booking.value.country) + ", " + _toDisplayString(booking.value.postcode), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_125, [
                              _createElementVNode("span", _hoisted_126, _toDisplayString(booking.value.organisation.address_line_one) + ", " + _toDisplayString(booking.value.organisation.address_line_two), 1),
                              _createElementVNode("span", _hoisted_127, _toDisplayString(booking.value.organisation.city) + ", " + _toDisplayString(booking.value.organisation.county), 1),
                              _createElementVNode("span", _hoisted_128, _toDisplayString(booking.value.organisation.country) + ", " + _toDisplayString(booking.value.organisation.postcode), 1)
                            ]))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'individual')
        ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
            _createElementVNode("table", _hoisted_130, [
              _hoisted_131,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_132, [
                  _hoisted_133,
                  _createElementVNode("td", _hoisted_134, [
                    _createElementVNode("span", _hoisted_135, _toDisplayString(booking.value.user.first_name) + " " + _toDisplayString(booking.value.user.last_name), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_136, [
                  _hoisted_137,
                  (booking.value.user.job_role && booking.value.user.job_role.data)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_138, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.user.job_role.data, (role) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "block",
                            key: role
                          }, _toDisplayString(role), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("tr", _hoisted_139, [
                  _hoisted_140,
                  _createElementVNode("td", _hoisted_141, [
                    (booking.value.dietary_requirements === 'Yes')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_142, _toDisplayString(booking.value.dietary_requirements_info), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_143, "None"))
                  ])
                ]),
                _createElementVNode("tr", _hoisted_144, [
                  _hoisted_145,
                  _createElementVNode("td", _hoisted_146, [
                    (booking.value.accessibility_requirements === 'Yes')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_147, _toDisplayString(booking.value.accessibility_requirements_info), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_148, "None"))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'course')
        ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
            _createElementVNode("table", _hoisted_150, [
              _hoisted_151,
              _createElementVNode("tbody", _hoisted_152, [
                _createElementVNode("tr", _hoisted_153, [
                  _hoisted_154,
                  _createElementVNode("td", _hoisted_155, _toDisplayString(booking.value.event?.first_event_date && booking.value.event?.template.delivery !== "e-learning" ? new Date(booking.value.event?.first_event_date).toLocaleDateString() : "N/A"), 1)
                ]),
                _createElementVNode("tr", _hoisted_156, [
                  _hoisted_157,
                  _createElementVNode("td", _hoisted_158, _toDisplayString(getInitiateComplete()), 1)
                ]),
                _createElementVNode("tr", _hoisted_159, [
                  _hoisted_160,
                  _createElementVNode("td", _hoisted_161, [
                    (booking.value.completed_at)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_162, _toDisplayString(new Date(booking.value.completed_at).toLocaleDateString()), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value, (course, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 even:bg-gray-200",
                    key: course.id
                  }, [
                    _createElementVNode("td", _hoisted_163, _toDisplayString(index === 0 ? "Courses" : ""), 1),
                    _createElementVNode("td", _hoisted_164, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_165, _toDisplayString(course.event?.name), 1),
                        (course && course.user_attended)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_166, "Completed " + _toDisplayString(new Date(course.completed_at).toLocaleDateString()), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_167, [
                              (course.event?.first_event_date)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_168, [
                                    (new Date(course.event.first_event_date) > new Date())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_169, [
                                          _hoisted_170,
                                          _createTextVNode("   - (starts " + _toDisplayString(new Date(course.event.first_event_date).toLocaleDateString()) + ") ", 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_171, [
                                          _hoisted_172,
                                          _createTextVNode("   - (started " + _toDisplayString(new Date(course.event.first_event_date).toLocaleDateString()) + ") ", 1)
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _createElementVNode("div", null, [
                        (_unref(shouldShowCertificateUrl)(course))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _unref(getCertificateUrl)(course, course.user),
                              class: "px-2 text-blue"
                            }, " View Certificate ", 8, _hoisted_173))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("tr", _hoisted_174, [
                  _hoisted_175,
                  _createElementVNode("td", _hoisted_176, [
                    _createElementVNode("span", _hoisted_177, _toDisplayString(booking.value.user.subscription_status), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_178, [
                  _hoisted_179,
                  _createElementVNode("td", _hoisted_180, [
                    (booking.value.user.subscription_status !== 'none')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_181, _toDisplayString(new Date(booking.value.user.subscription_end).toLocaleDateString()), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_182, [
                  _hoisted_183,
                  _createElementVNode("td", _hoisted_184, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value.filter(i => userLists.value.find(j => i.brevo_id === j)), (list) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: list.id,
                        class: "mt-4"
                      }, [
                        _createElementVNode("div", _hoisted_185, [
                          _createElementVNode("span", null, _toDisplayString(list.name), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!booking.value.payment_confirmed && !booking.value.user_removed)
        ? (_openBlock(), _createBlock(DefaultButton, {
            key: 5,
            type: "primary",
            class: "my-8",
            onClick: updatePaymentStatus
          }, {
            default: _withCtx(() => [
              _createTextVNode("Mark as Reviewed and Paid")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})